import React from 'react';
import { Settings, LogOut, User, Menu, RefreshCw } from 'lucide-react';
import DatabaseStatus from '../DatabaseStatus/DatabaseStatus';
import { useDeviceDetect } from '../../hooks/useDeviceDetect';

interface HeaderProps {
  onLogout?: () => void;
  onMenuToggle?: () => void;
  onRefresh?: () => void;
  user?: {
    email: string;
    nombre: string;
    role: string;
  } | null;
}

const Header: React.FC<HeaderProps> = ({ onLogout, user, onMenuToggle, onRefresh }) => {
  const { isTablet, isMobile } = useDeviceDetect();
  
  return (
    <header className="bg-cream shadow-sm border-b border-warm-brown/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          <div className="flex items-center flex-1">
            {/* Left section */}
            <div className="flex items-center space-x-4 flex-1">
              {onMenuToggle && (isTablet || isMobile) && (
                <button
                  onClick={onMenuToggle}
                  className="p-2 rounded-lg bg-warm-brown/10 text-warm-brown hover:bg-warm-brown/20 transition-colors"
                  aria-label="Menu"
                >
                  <Menu size={24} />
                </button>
              )}
              <div className="bg-white p-2 rounded-lg shadow-sm flex-shrink-0">
                <img 
                  src="/alere-logo.png" 
                  alt="Alere Café" 
                  className="h-12 w-auto object-contain"
                />
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold text-dark-text font-heading">
                  Control de Insumos
                </h1>
                <p className="text-sm text-medium-gray">
                  Alere Café
                </p>
              </div>
            </div>
            
            {/* Center section - MongoDB status */}
            <div className="hidden md:flex justify-center">
              <DatabaseStatus />
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            {user && (
              <div className="flex items-center space-x-2 text-sm text-medium-gray">
                <User size={18} />
                <span>{user.nombre}</span>
                <span className="text-xs bg-warm-brown/10 px-2 py-1 rounded-full">
                  {user.role === 'admin' ? 'Administrador' : 'Barista'}
                </span>
              </div>
            )}
            {isTablet && onRefresh && (
              <button 
                onClick={onRefresh}
                className="p-2 rounded-lg bg-warm-brown/10 text-warm-brown hover:bg-warm-brown/20 transition-colors"
                title="Actualizar página"
              >
                <RefreshCw size={20} />
              </button>
            )}
            <button className="p-2 rounded-lg bg-warm-brown/10 text-warm-brown hover:bg-warm-brown/20 transition-colors">
              <Settings size={20} />
            </button>
            {onLogout && (
              <button 
                onClick={onLogout}
                className="p-2 rounded-lg bg-warm-brown/10 text-warm-brown hover:bg-warm-brown/20 transition-colors"
                title="Cerrar sesión"
              >
                <LogOut size={20} />
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;